import fetchWrapper from '../fetchWrapper';

export function getLimits(groupId: string) {
  return fetchWrapper(`/nds/${groupId}/limits`, {
    method: 'GET',
  }).then((resp) => resp.json());
}
